import { PromotionCard } from '@purpur/library';
import { purpurBreakpointMd } from '@purpur/library/tokens';
import styled, { css } from 'styled-components';

import { getPurpurColor, getPurpurSpacing } from '@telialt/common-theme/src/purpurSelectors';

const baseColor = getPurpurColor('backgroundToneOnToneQuaternary');

const gradualTransitionShade = css`
    background: linear-gradient(
        to right,
        color-mix(in srgb, ${baseColor}, transparent 0%),
        color-mix(in srgb, ${baseColor}, transparent 25%),
        color-mix(in srgb, ${baseColor}, transparent 50%),
        color-mix(in srgb, ${baseColor}, transparent 75%),
        color-mix(in srgb, ${baseColor}, transparent 100%)
    );
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 50%;
    height: 100%;
`;

export const LeadPromotionCard = styled(PromotionCard)`
    [class*='_purpur-promotion-card__image-wrapper--decorative'] {
        display: none;

        @container promotion-card (min-width: ${purpurBreakpointMd}) {
            display: block;
        }

        &:before {
            ${gradualTransitionShade}
        }
    }
`;

export const PromotionCardBody = styled.div`
    margin-top: ${getPurpurSpacing('250')};
`;
